import React from 'react';
import './index.css';

export default () => (
  <div className="footer">
    Copyright &copy; 2019 <a href="https://github.com/jeasonstudio">Jeason</a>{' '}
    with ❤️
  </div>
);
